export default __webpack_public_path__ + "static/media/Privacy-Policy.29fbb361.svg";